import { useState } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import VitalManualEntryLayout from "../../components/Common/VitalManualEntryLayout";
import { BloodPressureInput } from "../../components/Common/VitalInput";

export interface BloodPressureManualEntryProps {
  onBack?: () => void;
  onCancel?: () => void;
  onSave?: () => void;
}

export default function BloodPressureManualEntry({
  onBack,
  onCancel,
  onSave,
}: BloodPressureManualEntryProps = {}) {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [systolic, setSystolic] = useState("");
  const [diastolic, setDiastolic] = useState("");

  const handleBack = onBack ?? (() => navigate(-1));
  const handleCancel = onCancel ?? (() => navigate(-1));

  const handleSave = () => {
    // TODO: Implement save functionality
    console.log("Saving blood pressure:", { systolic, diastolic });
    if (onSave) onSave();
    else navigate(-1);
  };

  return (
    <VitalManualEntryLayout
      title={t("BloodPressure.manualEntry.title")}
      onBack={handleBack}
      onCancel={handleCancel}
      onSave={handleSave}
      isSaveDisabled={!systolic || !diastolic}
      cancelText={t("BloodPressure.manualEntry.cancel")}
      saveText={t("BloodPressure.manualEntry.save")}
    >
      <BloodPressureInput
        systolic={systolic}
        diastolic={diastolic}
        onSystolicChange={setSystolic}
        onDiastolicChange={setDiastolic}
        systolicLabel={t("BloodPressure.manualEntry.systolicLabel")}
        diastolicLabel={t("BloodPressure.manualEntry.diastolicLabel")}
        unit={t("BloodPressure.unit")}
      />
    </VitalManualEntryLayout>
  );
}
